<template>
  <div class="about">
    <h1>This is an about page</h1>
    <h3>{{ $t('message') }}</h3>
  </div>
</template>
